import styled, { CreateStyled } from '@emotion/styled'
import { lightTheme } from './light'

export type Theme = typeof lightTheme
export default styled as CreateStyled<Theme>
export { lightTheme }
export * from './dark'
export * from './types.d'
export { default as ThemeContexts } from './theme-context'
